"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventbriteHeader = void 0;
var EventbriteHeader;
(function (EventbriteHeader) {
    /**
     * Valid SOA Token that can be used to invoke PySOA services
     */
    EventbriteHeader["EB_SOA_TOKEN"] = "eb-soa-token";
    /**
     * Eventbrite's public user id
     */
    EventbriteHeader["EB_USER_ID"] = "eb-user-id";
    /**
     * Eventbrite's public organization id, taken from the active_organization_id cookie
     */
    EventbriteHeader["EB_ORGANIZATION_ID"] = "eb-organization-id";
    /**
     * Eventbrite's guest ID, used for ad tracking, taken from the guest_id cookie
     */
    EventbriteHeader["EB_GUEST_ID"] = "eb-guest-id";
    /**
     * Eventbrite's session ID, maps to core's session ID
     */
    EventbriteHeader["EB_SESSION_ID"] = "eb-session-id";
    /**
     * Generated by core and used during troubleshooting, this id belongs to the PySOA world
     */
    EventbriteHeader["EB_CORRELATION_ID"] = "eb-correlation-id";
    /**
     * Used for experimentation
     */
    EventbriteHeader["EB_STABLE_ID"] = "eb-stable-id";
    /**
     * Eventbrite's host, used to extract the eb tld: www.eventbrite.com for example
     */
    EventbriteHeader["EB_HOST"] = "eb-host";
    /**
     * Eventbrite user Locale, calculated based on url, tld, and headers.
     */
    EventbriteHeader["EB_LANG"] = "eb-lang";
    /**
     * AWS Request ID, this header is automatically added as a response header
     * We're mapping it to a request header to the origin from Apigateway's request ID
     */
    EventbriteHeader["AMZN_REQUESTID"] = "x-amzn-requestid";
})(EventbriteHeader = exports.EventbriteHeader || (exports.EventbriteHeader = {}));
//# sourceMappingURL=headers.js.map